export const MENTOR = 'mentor'
export const SET_MENTORS_LIST = MENTOR + '/SET_MENTORS_LIST'
export const SET_MENTOR = MENTOR + '/SET_MENTOR'
export const SET_APPLICATIONS_LIST = MENTOR + '/SET_APPLICATIONS_LIST'
export const SET_PENDING_EDIT_REQUESTS_LIST = MENTOR + '/SET_PENDING_EDIT_REQUESTS_LIST'